module.exports = __webpack_public_path__ + "media/assets/icons/review-sites-6460525b808bdad65d01a7c8a67a5e6f.svg";